import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import axiosInstance from 'services/axiosInstance'

interface UseGetOptions<T> extends Omit<UseQueryOptions<T, Error, T, readonly string[]>, 'queryKey' | 'queryFn'> {
  enabled?: boolean
}

const useGet = <T = unknown,>(key: readonly string[], url: string, options?: UseGetOptions<T>) => {
  const fetchData = async (): Promise<T> => {
    const { data } = await axiosInstance.get<T>(url)
    return data
  }

  const defaultOptions: UseGetOptions<T> = {
    enabled: true,
    retry: false,
    ...options,
  }

  return useQuery({
    queryKey: key,
    queryFn: fetchData,
    ...defaultOptions,
  })
}

export default useGet
